import React, { useEffect, useState, useCallback } from 'react';

import debounce from 'lodash.debounce';

import { Box, styled, Grid } from '@mui/material';
import { AddLocationAlt } from '@mui/icons-material';

import { useError } from 'contexts/ErrorContext';
import { useLocations, TYPES as LOCATION_TYPES } from 'services/location';

import TitlePanel from 'components/Panels/TitlePanel';
import ListAndDetailsPanel from 'components/Panels/ListAndDetailsPanel';

import LocationList from './content/LocationList';
import LocationDetails from './content/LocationDetails';
import LocationModal from './content/NewLocationModal';

const ContentContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(0),
    width: '100%',
}));

const LocationsScreen = () => {
    const locationContext = useLocations();
    const errorContext = useError();
    // MTODO: move to reducer and change on every location API request
    const [addLocationPopupOpen, setAddLocationPopupOpen] = useState(false);

    const titleActions = [
        {
            title: 'Add Location',
            onClick: () => setAddLocationPopupOpen(true),
            iconComponent: AddLocationAlt,
        },
    ];

    const reloadLocations = () => {
        locationContext.actions.refreshLocations(
            { filter: locationContext.state.filters, textQuery: locationContext.state.searchTerm },
            errorContext,
        );
    };

    useEffect(
        () => reloadLocations(),
        [],
    );

    const newLocationModalElem = addLocationPopupOpen ? (
        <LocationModal open={addLocationPopupOpen} onClose={() => {
            setAddLocationPopupOpen(false);
            locationContext.DISPATCH({ type: LOCATION_TYPES.CLEAR_NEW_LOCATION });
        }} />
    ) : null;

    return (
        <Grid container display={'flex'} direction={'column'}>
            {newLocationModalElem}
            <TitlePanel title='Locations' actions={titleActions} />
            <Grid container display={'flex'}>
                <ContentContainer>
                    <ListAndDetailsPanel
                        list={locationContext?.state?.locations || []}
                        singularTitle='Location'
                        pluralTitle='Locations'
                        listElement={LocationList}
                        detailElement={LocationDetails}
                        loaded={locationContext.state.loaded}
                    />
                </ContentContainer>
            </Grid>
        </Grid>
    );
};

export default LocationsScreen;
